export default "/images/finances.svg?363e05823216e6f7bfd6ffa8317ab588";